import React, { useEffect, useRef, useState } from 'react'
import styles from './CfAppBanner.module.scss'
import CustomImage from '../CustomImage'
import { Container } from 'react-bootstrap'

const CfAppBanner = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [initialBannerClick, setInitialBannerClick] = useState<boolean>(true);
  const handleButtonClick = () => {
    ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if(initialBannerClick) {
      setTimeout(() => {
        ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start'  });
      }, 600);
      setInitialBannerClick(false);
    }
  };

  const stickyAppBanner = () => {
    const element = document.createElement('div');
    element.classList.add(styles.stickyAppBanner);
    element.id = 'sticky-app-banner';  
    element.innerHTML = `<span>Download coursefinder app</span><img src='https://assets.studies-overseas.com/cancel_fc437b3795.svg'  id='close-sticky-app-banner'>`;
    element.addEventListener('click', handleButtonClick);
    return element;
  }

  const removeStickyAppBanner = (e: any) => {
    e.stopPropagation();
    const stickyAppBannerElement = document.getElementById('sticky-app-banner');
    if (stickyAppBannerElement) {
      stickyAppBannerElement.remove();
    }
  };

  useEffect(() => {
    if(window !== undefined) {
      const element = stickyAppBanner();
      const header = document.getElementById('header-navbar');
      header?.parentElement?.prepend(element);
      const closeStickyAppBanner = document.getElementById('close-sticky-app-banner');
      closeStickyAppBanner?.addEventListener('click', removeStickyAppBanner);
    }
  }, [])

  return (
    <div className={styles.appBannerWrapper} ref={ref}>
      <div className={styles.appBanner}>
        <Container>
          <div className={styles.contentWrapper}>
            <div className={styles.textBox}>
              <h2 className={styles.heading}>Download coursefinder.ai</h2>
              <p className={styles.description}>One app for seamless student recruitment process. <br />Download the app to make your recruitment process quicker & smoother.</p>
              <div className={styles.appLink}>
                <a href='https://apps.apple.com/ph/app/coursefinder-ai/id6473614202' className={styles.appStore}>
                  <CustomImage
                    src='https://assets.studies-overseas.com/apple_store_abb7e05cbc.png'
                    width={294}
                    height={86}
                    alt='Apple Store'
                  />
                </a>
                <a href='https://play.google.com/store/apps/details?id=kc.coursefinder.ai' className={styles.playStore}>
                  <CustomImage
                    src='https://assets.studies-overseas.com/play_store_78a6c36f3b.png'
                    width={294}
                    height={86}
                    alt='Play Store'
                  />
                </a>
              </div>
            </div>
            <div className={styles.appImage}>
              <CustomImage
                src='https://assets.studies-overseas.com/coursefinder_7beb6794c4.png'
                width={630}
                height={740}
                alt='CF App Banner'
              />
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default CfAppBanner